import useSWR from "swr";
import fetcher from "./fetcher";

const endpoint = "/api/talentDashboard/getPaidV2/splits";

export default function useGetPaidSplits() {
  const { data, error, mutate } = useSWR(endpoint, fetcher);

  return {
    splits: data?.payoutCuts ?? [],
    isLoading: !data && !error,
    error,
    refresh: mutate,
  };
}
